import type { ApolloError } from '@apollo/client';
import { skipToken, useSuspenseQuery } from '@apollo/client';

import type { CountryCodesAlpha2 } from '@xing-com/crate-common-graphql-types';
import { GetUserCountryDocument } from '@xing-com/crate-jobs-graphql';

export type UserCountry = {
  country?: CountryCodesAlpha2;
  error?: ApolloError;
};

type Props = {
  skip?: boolean;
};

export const useUserCountry = ({ skip }: Props): UserCountry => {
  const { error, data } = useSuspenseQuery(
    GetUserCountryDocument,
    skip ? skipToken : undefined
  );
  const country =
    data?.viewer?.xingId?.location?.country?.countryCode ?? undefined;

  return { country, error };
};
